import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Upload, Cpu, FileSpreadsheet } from 'lucide-react';
const steps = [{
  id: 1,
  title: 'Upload Discovery Export',
  description: 'You provide discovery export (dat file, load file + extracted text/natives). We handle the ingestion programmatically.',
  icon: Upload
}, {
  id: 2,
  title: 'AI Analysis & QA',
  description: 'Our AI reads every document to identify what it is, what it says, and why it matters. Quality control checks ensure accuracy.',
  icon: Cpu
}, {
  id: 3,
  title: 'Receive Results',
  description: 'Delivery within 48-72 hours. Get a clean Excel spreadsheet or access our secure web-based review platform.',
  icon: FileSpreadsheet
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-113">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-4" data-id="element-116">
            How It Works
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto" data-id="element-117">
            We use artificial intelligence to read every document in your
            discovery set - contracts, emails, memos, invoices, and everything
            else. What would take a review team weeks is completed in hours.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-118">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-200 -z-10" data-id="element-119" />

          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center bg-white p-6" data-id="element-120">
              <div className="w-24 h-24 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center mb-6 relative z-10 shadow-sm" data-id="element-121">
                <step.icon className="w-10 h-10 text-amber-600" strokeWidth={1.5} data-id="element-122" />
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-slate-900 text-white flex items-center justify-center font-bold text-sm border-2 border-white" data-id="element-123">
                  {step.id}
                </div>
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-124">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-125">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}